/**
 * Password Reset Components (TypeScript)
 * Simple redirects to server-side password reset
 */

import React, { useEffect } from 'react';

export const ForgotPassword: React.FC = () => {
  useEffect(() => {
    // Redirect to server-side forgot password
    window.location.href = '/forgot-password';
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Redirecting to password reset...</p>
      </div>
    </div>
  );
};

export const ResetPassword: React.FC = () => {
  useEffect(() => {
    // Redirect to server-side reset password
    window.location.href = '/reset-password';
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Redirecting to password reset...</p>
      </div>
    </div>
  );
};